import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		user: {
			email: '',
			password: '',
		},
		loggedIn: false,
		errors: [],
		profileData: []
		//SBTP servedByURL: ''
	},
	mutations: {
		login(state, login) {
			state.loggedIn = login;
		},
		user(state, user){
				state.user.email = user.email;
				state.user.password = user.password;
		},
		error(state, error) {
			state.errors.push(error);
		},
		storeProfileData(state, jsonData) {
			state.profileData = jsonData;
		},
		updateProfileAddChild(state, childData) {
			let childsList = state.profileData.children;
			childsList.push(childData);
			state.profileData.children = childsList;
		},
		updateProfileRemoveChild(state, membershipNumber) {
			let childsList = state.profileData.children;
			let removeIndex = childsList.map(function(item) {
				return item.membershipNumber;
			}).indexOf(membershipNumber);
			childsList.splice(removeIndex, 1);
			state.profileData.children = childsList;
		},
		updateProfileChangeAddress(state, addressData) {
			state.profileData.address.street = addressData.street;
			state.profileData.address.housenumber = addressData.housenumber;
			state.profileData.address.postcode = addressData.postcode;
			state.profileData.address.city = addressData.city;
			state.profileData.address.country = addressData.country;
		},
		updateProfileChangeFavoriteRestaurant(state, restaurant) {
			state.profileData.favoriteRestaurant = restaurant;
		},
		updateProfileChangePermissions(state, permissions){
			state.profileData.optin2.optinAgreement = permissions;
		}
		//SBTP
		// updateServedByIFrameSrc(state, src) {
		// 	state.servedByURL = src;
		// }
	},
	plugins: [new VuexPersistence().plugin]
});

export default store;
